/// <reference types="@shopify/polaris-types" />

const BENEFITS = [
  {
    title: "Elimina errores de dirección:",
    text: "A medida que los clientes escriben, aparecen sugerencias completas y precisas, reduciendo errores y garantizando consistencia.",
  },
  {
    title: "Acelera el llenado del formulario:",
    text: "Las sugerencias instantáneas permiten a los clientes completar sus formularios en una fracción del tiempo.",
  },
  {
    title: "Impulsa las tasas de conversión:",
    text: "Un proceso de compra optimizado y sin errores genera confianza, satisfacción e impulsa más conversiones.",
  },
];

export function ExplainerSection() {
  return (
    <s-section heading="¿Cómo funciona la validación de direcciones con Google Autocomplete?">
      <s-stack direction="block" gap="base">
        <s-text>
          Cuando los clientes comienzan a escribir su dirección, Google
          Autocomplete muestra al instante sugerencias precisas. Una vez que se
          selecciona una sugerencia, la dirección se rellena automáticamente,
          eliminando errores manuales y acelerando el proceso de completar el
          formulario.
        </s-text>

        <s-stack direction="block" gap="small-300">
          {BENEFITS.map(({ title, text }) => (
            <div
              key={title}
              style={{ display: "flex", gap: "8px", alignItems: "flex-start" }}
            >
              <span
                style={{
                  color: "#008060",
                  fontWeight: 700,
                  flexShrink: 0,
                  marginTop: "2px",
                }}
              >
                ✓
              </span>
              <s-text>
                <strong>{title}</strong> {text}
              </s-text>
            </div>
          ))}
        </s-stack>
      </s-stack>
    </s-section>
  );
}
